import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Navbar } from './NavBar/Navbar';
import { Footer } from './Footer/Footer';
import { EnrollmentRootStore } from '../root/EnrollmentRootStore';
import { LabelEditor } from '../../infrastructure/localization/LabelEditor';
import { ShowScreenSpinner } from '../../external/shared/spinner/ScreenSpinner';
import { KustomerChat } from '../external/KustomerChat';
import { ZccChat } from '../external/ZccChat';
import { OnetrustCookieBanner } from '../external/OnetrustCookieBanner';
import { PickupPointModal } from '../external/PickupPointModal';
import { getRootStore } from '../root/RootStoreUtils';
import { extractCountryAndCulture, readAuthToken, resolveHtmlLang } from '../external/chat-locale-utils';

interface Props {
  store: EnrollmentRootStore;
}

export const EnrollmentLayout = observer<Props>(({ store, children }) => {
  useEffect(() => {
    function onresize() {
      store.updateWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', onresize);
    return () => {
      window.removeEventListener('resize', onresize);
    };
  }, [store]);
  const { locale } = store.localeManager.language;
  const root = getRootStore(store);
  const countryIso3 = root.enrollmentStatus.countryIso3;

  useEffect(() => {
    const token = readAuthToken();
    const { country, culture } = extractCountryAndCulture(token);
    const targetLocale = resolveHtmlLang(locale, country || countryIso3, culture);
    const html = document.documentElement;
    if (html.lang !== targetLocale) {
      html.lang = targetLocale;
    }
  }, [locale, countryIso3]);

  return (
    <>
      <Navbar />
      <div>{children}</div>
      <Footer locale={locale} />
      {store.moduleStores?.shippingAddressEntry && (
        <PickupPointModal store={store.moduleStores.shippingAddressEntry.pickupPointModal} />
      )}
      {store.showSpinner && <ShowScreenSpinner />}
      <KustomerChat locale={locale} />
      <ZccChat locale={locale} countryIso3={countryIso3} />
      <OnetrustCookieBanner />
      {process.env.NODE_ENV !== 'production' && <LabelEditor />}
    </>
  );
});
